<button
  type="button"
  [disabled]="disabled()"
  [ngClass]="buttonClasses()"
  [style.background-color]="bgColor()"
  [style.color]="textColor()"
  [style.border-color]="borderColor()"
  (click)="buttonClick.emit()"
  class="inline-flex cursor-pointer items-center justify-center rounded-md px-4 py-1.5 text-body transition-colors duration-300"
>
  {{ label() }}
</button>
